import React, { useMemo } from "react";

import { Car } from "../../../../../../services";
import { CellContentRoot } from "../../../../../LightTable";

const RegistrationNumberCellContent: React.FC<
	RegistrationNumberCellContent.Props
> = ({ item }) => {
	const content = useMemo(
		() => item.registrationNumber ?? "",
		[item.registrationNumber],
	);

	return (
		<CellContentRoot alignItems="center" w="100%" h="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace RegistrationNumberCellContent {
	interface Props {
		item: Car.Model;
	}
}

export default RegistrationNumberCellContent;
